import WeatherCard from './WeatherCard';


export const Cards = {
  WeatherCard,
};
